export const isFilePDF = (file: File): boolean =>
  file.type === 'application/pdf' || file.name.endsWith('.pdf');
